import isEmpty from "lodash/isEmpty";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StoreState } from "../../redux/store";

const useUserOnlineHook: (username?: string) => boolean = (username) => {
  const { onlineUsers } = useSelector((state: StoreState) => state.messages);
  const [isOnline, setIsOnline] = useState<boolean>(false);

  useEffect(() => {
    if (!isEmpty(onlineUsers)) {
      const index = onlineUsers.findIndex((user) => user.username === username);
      if (index !== -1) {
        setIsOnline(true);
      } else {
        setIsOnline(false);
      }
    }
  }, [onlineUsers, username]);

  return isOnline;
};

export default useUserOnlineHook;
